<script setup>
import { computed } from 'vue';
import { REPLY_EDITOR_MODES } from './constants';

const props = defineProps({
  mode: { type: String, default: REPLY_EDITOR_MODES.REPLY },
  disabled: { type: Boolean, default: false },
  isReplyRestricted: { type: Boolean, default: false },
});
const emit = defineEmits(['toggleMode']);
const isPrivate = computed(
  () => props.isReplyRestricted || props.mode === REPLY_EDITOR_MODES.NOTE
);
const selectMode = privateMode => {
  if (
    props.disabled ||
    props.isReplyRestricted ||
    isPrivate.value === privateMode
  )
    return;
  emit('toggleMode');
};
</script>

<template>
  <div
    class="flex min-w-0 shrink-0 items-stretch gap-1"
    role="group"
    :aria-label="$t('CONVERSATION.REPLYBOX.MODE_LABEL')"
  >
    <button
      type="button"
      class="min-h-11 border-b-2 px-2.5 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-blue-8"
      :class="
        isPrivate
          ? 'border-transparent text-n-slate-11 hover:text-n-slate-12'
          : 'border-n-blue-11 font-semibold text-n-blue-11'
      "
      :aria-pressed="!isPrivate"
      :disabled="disabled || isReplyRestricted"
      @click="selectMode(false)"
    >
      {{ $t('CONVERSATION.REPLYBOX.REPLY') }}
    </button>
    <button
      type="button"
      class="inline-flex min-h-11 items-center gap-1.5 border-b-2 px-2.5 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-amber-8"
      :class="
        isPrivate
          ? 'border-n-amber-11 font-semibold text-n-amber-11'
          : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
      "
      :aria-pressed="isPrivate"
      :disabled="disabled || isReplyRestricted"
      @click="selectMode(true)"
    >
      <span class="i-lucide-lock-keyhole size-3 shrink-0" aria-hidden="true" />
      {{ $t('CONVERSATION.REPLYBOX.PRIVATE_NOTE') }}
    </button>
  </div>
</template>
